/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
  '/api/v1/template-gallery/templates/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Templates
     * @description Get a list of templates in a paginate way, support filter, search, sort, and pagination
     *
     *         filter: list of str in format as filter_field:filter_operator:value
     *         search: a str to search in the title and description
     *         sort: list of str in format as sort_field:sort_order
     *         specialty_groups: list of specialty group names to expand search when < 12 results
     *
     *         filter_field: template_category, source_region, country, specialty, views_count, imports_count
     *         filter_operator: eq, gt, lt
     *         sort_field: created_at, updated_at, views_count, imports_count, title
     *         sort_order: 1 (ascending), -1 (descending)
     */
    get: operations['get_templates_api_v1_template_gallery_templates__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/templates/{url_path}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template By Url Path
     * @description Get template details by template url path
     */
    get: operations['get_template_by_url_path_api_v1_template_gallery_templates__url_path__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Templates
     * @description List templates with filtering and pagination
     */
    get: operations['list_templates_api_v1_internal_template_gallery_templates__get'];
    put?: never;
    /**
     * Create Template
     * @description Create a new template
     */
    post: operations['create_template_api_v1_internal_template_gallery_templates__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Batch Create Templates
     * @description Create multiple templates in batch
     */
    post: operations['batch_create_templates_api_v1_internal_template_gallery_templates_batch_post'];
    /**
     * Batch Delete Templates
     * @description Delete multiple templates in batch (soft delete)
     */
    delete: operations['batch_delete_templates_api_v1_internal_template_gallery_templates_batch_delete'];
    options?: never;
    head?: never;
    /**
     * Batch Update Templates
     * @description Update multiple templates in batch
     */
    patch: operations['batch_update_templates_api_v1_internal_template_gallery_templates_batch_patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/bulk-update-by-specialty': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Bulk Update By Specialty
     * @description Bulk update templates by specialty name
     */
    patch: operations['bulk_update_by_specialty_api_v1_internal_template_gallery_templates_bulk_update_by_specialty_patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/bulk-set-seo-fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Bulk Set Seo Fields
     * @description Set seo_content and/or seo_context on multiple templates
     */
    patch: operations['bulk_set_seo_fields_api_v1_internal_template_gallery_templates_bulk_set_seo_fields_patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template By Id
     * @description Get template detail by template ID, even deleted ones
     */
    get: operations['get_template_by_id_api_v1_internal_template_gallery_templates__template_id__get'];
    put?: never;
    post?: never;
    /**
     * Mark Template As Deleted
     * @description Delete a template
     */
    delete: operations['mark_template_as_deleted_api_v1_internal_template_gallery_templates__template_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Template
     * @description Update an existing template
     */
    patch: operations['update_template_api_v1_internal_template_gallery_templates__template_id__patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/{template_id}/restore': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Restore Template
     * @description Restore a deleted template
     */
    patch: operations['restore_template_api_v1_internal_template_gallery_templates__template_id__restore_patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/{template_id}/import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Import Template By Id
     * @description Increase imports count of a template
     */
    patch: operations['import_template_by_id_api_v1_internal_template_gallery_templates__template_id__import_patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/{template_id}/like': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Like Status
     * @description Check if user has liked a template (internal service call)
     */
    get: operations['get_like_status_api_v1_internal_template_gallery_templates__template_id__like_get'];
    put?: never;
    /**
     * Like Template
     * @description Like a template (internal service call)
     */
    post: operations['like_template_api_v1_internal_template_gallery_templates__template_id__like_post'];
    /**
     * Unlike Template
     * @description Unlike a template (internal service call)
     */
    delete: operations['unlike_template_api_v1_internal_template_gallery_templates__template_id__like_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/templates/likes/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Batch Like Status
     * @description Get like status for multiple templates (internal service call)
     */
    post: operations['get_batch_like_status_api_v1_internal_template_gallery_templates_likes_batch_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/healthcheck': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Healthcheck */
    get: operations['healthcheck_api_v1_template_gallery_healthcheck_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/auth/token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Jwt */
    post: operations['generate_jwt_api_v1_template_gallery_auth_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/integrations-marketplace/integrations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Integrations */
    get: operations['list_integrations_api_v1_template_gallery_integrations_marketplace_integrations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/integrations-marketplace/integrations/integration-providers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Integration Providers */
    get: operations['list_integration_providers_api_v1_template_gallery_integrations_marketplace_integrations_integration_providers_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/integrations-marketplace/integrations/{language}/{integration_slug}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Integration By Slug And Language */
    get: operations['get_integration_by_slug_and_language_api_v1_template_gallery_integrations_marketplace_integrations__language___integration_slug__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/integrations-marketplace/integrations/general': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Integration By Ehr Provider And Language */
    get: operations['get_integration_by_ehr_provider_and_language_api_v1_template_gallery_integrations_marketplace_integrations_general_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/integrations-marketplace/integrations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Integrations */
    get: operations['list_integrations_api_v1_internal_template_gallery_integrations_marketplace_integrations_get'];
    put?: never;
    /** Create Integration */
    post: operations['create_integration_api_v1_internal_template_gallery_integrations_marketplace_integrations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/integrations-marketplace/integrations/{integration_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Integration By Id */
    get: operations['integration_by_id_api_v1_internal_template_gallery_integrations_marketplace_integrations__integration_id__get'];
    put?: never;
    post?: never;
    /** Delete Integration */
    delete: operations['delete_integration_api_v1_internal_template_gallery_integrations_marketplace_integrations__integration_id__delete'];
    options?: never;
    head?: never;
    /** Update Integration */
    patch: operations['update_integration_api_v1_internal_template_gallery_integrations_marketplace_integrations__integration_id__patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/integrations-marketplace/integration-providers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Integration Providers */
    get: operations['list_integration_providers_api_v1_internal_template_gallery_integrations_marketplace_integration_providers_get'];
    put?: never;
    /** Create Integration Provider */
    post: operations['create_integration_provider_api_v1_internal_template_gallery_integrations_marketplace_integration_providers_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/integrations-marketplace/integration-providers/{provider_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Integration Provider By Id */
    get: operations['integration_provider_by_id_api_v1_internal_template_gallery_integrations_marketplace_integration_providers__provider_id__get'];
    put?: never;
    post?: never;
    /** Delete Integration Provider */
    delete: operations['delete_integration_provider_api_v1_internal_template_gallery_integrations_marketplace_integration_providers__provider_id__delete'];
    options?: never;
    head?: never;
    /** Update Integration Provider */
    patch: operations['update_integration_provider_api_v1_internal_template_gallery_integrations_marketplace_integration_providers__provider_id__patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/integrations-marketplace/listing-page-config': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Listing Page Config */
    get: operations['get_listing_page_config_api_v1_internal_template_gallery_integrations_marketplace_listing_page_config_get'];
    /** Upsert Listing Page Config */
    put: operations['upsert_listing_page_config_api_v1_internal_template_gallery_integrations_marketplace_listing_page_config_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/heidi-answers/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Published Answers
     * @description Return published Heidi Answers with optional filtering.
     */
    get: operations['list_published_answers_api_v1_template_gallery_heidi_answers__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/template-gallery/heidi-answers/{slug}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Answer By Slug
     * @description Return a single published Heidi Answer by its `question_slug`.
     *
     *     Returns 404 when the resolved entity is not `published` so
     *     `pending_review` drafts never leak onto the public surface.
     */
    get: operations['get_answer_by_slug_api_v1_template_gallery_heidi_answers__slug__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/heidi-answers/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Answers */
    get: operations['list_answers_api_v1_internal_template_gallery_heidi_answers__get'];
    put?: never;
    /** Create Answer */
    post: operations['create_answer_api_v1_internal_template_gallery_heidi_answers__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/heidi-answers/{answer_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Answer */
    get: operations['get_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Answer
     * @description Delete an answer.
     *
     *     Default behaviour (`hard=false`) is a soft delete: stamps
     *     `deleted_at` so the public list/by-slug endpoints stop returning
     *     the answer, but the row is retained in Mongo for audit and the
     *     `question_slug` remains in the unique index.
     *
     *     `hard=true` permanently removes the row, freeing the slug for
     *     re-publishing. Used by the admin "Delete permanently" flow on
     *     Scribe-Admin and called only after the ml-scribe draft has
     *     transitioned through `unpublished` first - hard delete is never
     *     the first action against a live published row.
     */
    delete: operations['delete_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__delete'];
    options?: never;
    head?: never;
    /** Update Answer */
    patch: operations['update_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__patch'];
    trace?: never;
  };
  '/api/v1/internal/template-gallery/heidi-answers/{answer_id}:approve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Approve Answer */
    post: operations['approve_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__approve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/heidi-answers/{answer_id}:reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Reject Answer */
    post: operations['reject_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/internal/template-gallery/heidi-answers/batch/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Bulk Upload Csv */
    post: operations['bulk_upload_csv_api_v1_internal_template_gallery_heidi_answers_batch_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
};
export type webhooks = Record<string, never>;
export type components = {
  schemas: {
    /** AnswerValidatorResponse */
    AnswerValidatorResponse: {
      /** Name */
      name: string;
      /** Credentials */
      credentials: string;
      /** Specialty */
      specialty: string;
      /** Role */
      role: string;
    };
    /** ApproveAnswerRequest */
    ApproveAnswerRequest: {
      /** Reviewed By */
      reviewed_by?: string | null;
    };
    /** BatchCreateTemplateContentRequest */
    BatchCreateTemplateContentRequest: {
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Structure */
      structure: string;
      /** Html */
      html?: string | null;
      /** Tone */
      tone?: string | null;
      /** Example Output */
      example_output: string;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** @default pdf */
      form_format: components['schemas']['FormFormat'];
      /** Xml Source */
      xml_source?: string | null;
      /** Seo Content */
      seo_content?: string | null;
      seo_context?: components['schemas']['SeoContext'] | null;
    };
    /** BatchCreateTemplateItem */
    BatchCreateTemplateItem: {
      /** Template Id */
      template_id: string;
      template_category: components['schemas']['TemplateCategory'];
      source_region: components['schemas']['Region'];
      /** Country */
      country?: string | null;
      /** Specialty */
      specialty: string;
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Clinic Id */
      clinic_id?: string | null;
      /** Clinic Name */
      clinic_name?: string | null;
      /** Preference Show Name */
      preference_show_name: boolean;
      /** Preference Show Clinic */
      preference_show_clinic: boolean;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      template_content: components['schemas']['BatchCreateTemplateContentRequest'];
      /**
       * Published At
       * Format: date-time
       */
      published_at: string;
      /** Url Path */
      url_path: string;
    };
    /** BatchCreateTemplateRequest */
    BatchCreateTemplateRequest: {
      /** Templates */
      templates: components['schemas']['BatchCreateTemplateItem'][];
    };
    /** BatchCreateTemplateResponse */
    BatchCreateTemplateResponse: {
      /** Created */
      created: components['schemas']['TemplateBasicInfo'][];
      /** Failed */
      failed: components['schemas']['TemplateFailedItem'][];
    };
    /** BatchDeleteTemplateRequest */
    BatchDeleteTemplateRequest: {
      /** Template Ids */
      template_ids: string[];
    };
    /** BatchDeleteTemplateResponse */
    BatchDeleteTemplateResponse: {
      /** Deleted */
      deleted: string[];
      /** Failed */
      failed: components['schemas']['TemplateFailedItem'][];
    };
    /**
     * BatchLikeStatusRequest
     * @description Request body for batch like status check.
     */
    BatchLikeStatusRequest: {
      /** User Id */
      user_id: string;
      /** Template Ids */
      template_ids: string[];
    };
    /**
     * BatchLikeStatusResponse
     * @description Response for batch checking like status.
     */
    BatchLikeStatusResponse: {
      /** Statuses */
      statuses: {
        [key: string]: boolean;
      };
    };
    /** BatchUpdateTemplateItem */
    BatchUpdateTemplateItem: {
      /** Template Id */
      template_id: string;
      template_category?: components['schemas']['TemplateCategory'] | null;
      /** Specialty */
      specialty?: string | null;
      /** Country */
      country?: string | null;
      /** Author Name */
      author_name?: string | null;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      template_content?: components['schemas']['TemplateContentUpdate'] | null;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Url Path */
      url_path?: string | null;
    };
    /** BatchUpdateTemplateRequest */
    BatchUpdateTemplateRequest: {
      /** Templates */
      templates: components['schemas']['BatchUpdateTemplateItem'][];
    };
    /** BatchUpdateTemplateResponse */
    BatchUpdateTemplateResponse: {
      /** Updated */
      updated: components['schemas']['TemplateBasicInfo'][];
      /** Failed */
      failed: components['schemas']['TemplateFailedItem'][];
    };
    /** Body_bulk_upload_csv_api_v1_internal_template_gallery_heidi_answers_batch_upload_post */
    Body_bulk_upload_csv_api_v1_internal_template_gallery_heidi_answers_batch_upload_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** BulkSetSeoFieldsRequest */
    BulkSetSeoFieldsRequest: {
      /** Items */
      items: {
        [key: string]: components['schemas']['SeoFieldsUpdate'];
      };
    };
    /** BulkSetSeoFieldsResponse */
    BulkSetSeoFieldsResponse: {
      /** Updated */
      updated: string[];
      /** Failed */
      failed: components['schemas']['TemplateFailedItem'][];
    };
    /** BulkUpdateBySpecialtyRequest */
    BulkUpdateBySpecialtyRequest: {
      /** Specialty */
      specialty: string;
      updates: components['schemas']['SpecialtyGroupsUpdate'];
    };
    /** BulkUpdateResponse */
    BulkUpdateResponse: {
      /** Updated Count */
      updated_count: number;
      /** Specialty */
      specialty: string;
    };
    /** BulkUploadResponse */
    BulkUploadResponse: {
      /** Success Count */
      success_count: number;
      /** Failed Count */
      failed_count: number;
      /** Errors */
      errors: {
        [key: string]: unknown;
      }[];
      /** Created */
      created: {
        [key: string]: unknown;
      }[];
    };
    /** CarouselBlockConfig */
    CarouselBlockConfig: {
      /** Id */
      id: string;
      /** Integration Slugs */
      integration_slugs: string[];
    } & {
      [key: string]: unknown;
    };
    /** CarouselBlockTranslation */
    CarouselBlockTranslation: {
      /** Title */
      title: string;
      /** Subtitle */
      subtitle: string;
    } & {
      [key: string]: unknown;
    };
    /** CarouselComponent */
    'CarouselComponent-Input': {
      config: components['schemas']['CarouselConfig'];
      /** Translations */
      translations?: {
        [key: string]: components['schemas']['CarouselTranslation'];
      };
    } & {
      [key: string]: unknown;
    };
    /** CarouselComponent */
    'CarouselComponent-Output': {
      config: components['schemas']['CarouselConfig'];
      /** Translations */
      translations?: {
        [key: string]: components['schemas']['CarouselTranslation'];
      };
    } & {
      [key: string]: unknown;
    };
    /** CarouselConfig */
    CarouselConfig: {
      /** Background Image Url */
      background_image_url: string;
      /** Blocks */
      blocks: components['schemas']['CarouselBlockConfig'][];
    } & {
      [key: string]: unknown;
    };
    /** CarouselTranslation */
    CarouselTranslation: {
      /** Title */
      title: string;
      /** Blocks */
      blocks?: {
        [key: string]: components['schemas']['CarouselBlockTranslation'];
      };
    } & {
      [key: string]: unknown;
    };
    /**
     * Country
     * @enum {string}
     */
    Country: Country;
    /** CreateHeidiAnswerRequest */
    CreateHeidiAnswerRequest: {
      /** Question Title */
      question_title: string;
      /** Question Slug */
      question_slug?: string | null;
      /** Specialty */
      specialty: string;
      /** Condition */
      condition: string;
      /** Question Type */
      question_type: string;
      /** Direct Answer */
      direct_answer: string;
      /** Validator Name */
      validator_name: string;
      /** Validator Credentials */
      validator_credentials: string;
      /** Validator Specialty */
      validator_specialty: string;
      /** Validator Role */
      validator_role: string;
      /** Country */
      country: string;
      /**
       * Validation Date
       * Format: date
       */
      validation_date: string;
      /**
       * Last Reviewed Date
       * Format: date
       */
      last_reviewed_date: string;
      /** Og Title */
      og_title?: string | null;
      /** Og Description */
      og_description?: string | null;
      /** Source Evidence Id */
      source_evidence_id?: string | null;
      /**
       * Sources
       * @default []
       */
      sources: {
        [key: string]: unknown;
      }[];
    };
    /** CreateTemplateRequest */
    CreateTemplateRequest: {
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      template_category: components['schemas']['TemplateCategory'];
      source_region: components['schemas']['Region'];
      /**
       * Country
       * @default
       */
      country: string;
      /** Specialty */
      specialty: string;
      /**
       * Clinical Content Group
       * @default
       */
      clinical_content_group: string;
      /**
       * Specialty Groups
       * @default []
       */
      specialty_groups: string[];
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Clinic Id */
      clinic_id?: string | null;
      /** Clinic Name */
      clinic_name?: string | null;
      /** Preference Show Name */
      preference_show_name: boolean;
      /** Preference Show Clinic */
      preference_show_clinic: boolean;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      /**
       * Views Count
       * @default 0
       */
      views_count: number;
      /**
       * Imports Count
       * @default 0
       */
      imports_count: number;
      /**
       * Version History
       * @default []
       */
      version_history: components['schemas']['TemplateVersion'][];
      /**
       * Searching Text
       * @default
       */
      searching_text: string;
      template_content: components['schemas']['TemplateContentV1'];
      /**
       * Published At
       * Format: date-time
       */
      published_at: string;
      /** Url Path */
      url_path: string;
    };
    /** DetailedTemplateResponse */
    DetailedTemplateResponse: {
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      /** Title */
      title: string;
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Deleted At */
      deleted_at?: string | null;
      template_category: components['schemas']['TemplateCategory'];
      source_region: components['schemas']['Region'];
      /**
       * Country
       * @default
       */
      country: string;
      /** Specialty */
      specialty: string;
      /**
       * Clinical Content Group
       * @default
       */
      clinical_content_group: string;
      /**
       * Specialty Groups
       * @default []
       */
      specialty_groups: string[];
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Clinic Id */
      clinic_id?: string | null;
      /** Clinic Name */
      clinic_name?: string | null;
      /** Views Count */
      views_count: number;
      /** Imports Count */
      imports_count: number;
      /**
       * Likes Count
       * @default 0
       */
      likes_count: number;
      /** Url Path */
      url_path: string;
      form_format?: components['schemas']['FormFormat'] | null;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      template_content: components['schemas']['TemplateContentV1'];
    };
    /** ErrorDetail */
    ErrorDetail: {
      /** Msg */
      msg: string;
      /** Type */
      type: string;
    };
    /** ErrorResponse */
    ErrorResponse: {
      /**
       * Status Code
       * @default 400
       */
      status_code: number;
      detail: components['schemas']['ErrorDetail'];
    };
    /** FormField */
    FormField: {
      /** Page */
      page: number;
      /** Field Name */
      field_name: string;
      /** Field Label */
      field_label?: string | null;
      /** Field Type */
      field_type?: string | null;
      /** Choice Values */
      choice_values?: string[] | null;
      /** Rect */
      rect?: {
        [key: string]: number;
      } | null;
      /** Event */
      event?: string[] | null;
      /** Javascript */
      javascript?: string[] | null;
      /** Max Len */
      max_len?: number | null;
      /** Radio Button Value */
      radio_button_value?: string | null;
    };
    /**
     * FormFormat
     * @enum {string}
     */
    FormFormat: FormFormat;
    /** GenerateJWTResponse */
    GenerateJWTResponse: {
      /** Token */
      token: string;
      /**
       * Expiration Time
       * Format: date-time
       */
      expiration_time: string;
    };
    /** GetTemplateListResponse */
    GetTemplateListResponse: {
      /** Templates */
      templates: components['schemas']['TemplateBasicInfo'][];
      /** Total */
      total: number;
      /** Page */
      page?: number | null;
      /** Page Size */
      page_size?: number | null;
      /** Pages */
      pages?: number | null;
      /** Recommended Templates */
      recommended_templates: components['schemas']['TemplateBasicInfo'][];
      /** Total Recommended Templates */
      total_recommended_templates: number;
      /** Disabled Filters */
      disabled_filters: components['schemas']['TemplateFilterBy'][];
    };
    /** HTTPValidationError */
    HTTPValidationError: {
      /** Detail */
      detail?: components['schemas']['ValidationError'][];
    };
    /** HeidiAnswerListResponse */
    HeidiAnswerListResponse: {
      /** Answers */
      answers: components['schemas']['HeidiAnswerResponse'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
      /** Pages */
      pages: number;
    };
    /** HeidiAnswerResponse */
    HeidiAnswerResponse: {
      /** Id */
      id?: string | null;
      /** Question Title */
      question_title: string;
      /** Question Slug */
      question_slug: string;
      /** Specialty */
      specialty: string;
      /** Condition */
      condition: string;
      /** Question Type */
      question_type: string;
      /** Direct Answer */
      direct_answer: string;
      validator: components['schemas']['AnswerValidatorResponse'];
      /** Country */
      country: string;
      /**
       * Validation Date
       * Format: date
       */
      validation_date: string;
      /**
       * Last Reviewed Date
       * Format: date
       */
      last_reviewed_date: string;
      /** Published At */
      published_at?: string | null;
      /** Og Title */
      og_title: string;
      /** Og Description */
      og_description: string;
      /** Source Evidence Id */
      source_evidence_id?: string | null;
      /**
       * Sources
       * @default []
       */
      sources: components['schemas']['HeidiAnswerSource'][];
      /**
       * Status
       * @default pending_review
       */
      status: string;
      /** Reviewed By */
      reviewed_by?: string | null;
      /** Reviewed At */
      reviewed_at?: string | null;
      /** Rejection Reason */
      rejection_reason?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
    };
    /** HeidiAnswerSource */
    HeidiAnswerSource: {
      /** Title */
      title: string;
      /** Url */
      url?: string | null;
      /** Source Type */
      source_type?: string | null;
      /** Cited Text */
      cited_text?: string | null;
    };
    /**
     * HeidiProducts
     * @enum {string}
     */
    HeidiProducts: HeidiProducts;
    /**
     * IntegrationCategory
     * @enum {string}
     */
    IntegrationCategory: IntegrationCategory;
    /**
     * IntegrationEligibilityMethod
     * @enum {string}
     */
    IntegrationEligibilityMethod: IntegrationEligibilityMethod;
    /** IntegrationFeatureCopy */
    IntegrationFeatureCopy: {
      /** Line 1 */
      line_1?: string | null;
      /** Line 2 */
      line_2?: string | null;
      /** Line 3 */
      line_3?: string | null;
      /** Icon 1 */
      icon_1?: string | null;
      /** Icon 2 */
      icon_2?: string | null;
      /** Icon 3 */
      icon_3?: string | null;
    };
    /** IntegrationFeatureCopyResponse */
    IntegrationFeatureCopyResponse: {
      /** Line 1 */
      line_1: string | null;
      /** Line 2 */
      line_2: string | null;
      /** Line 3 */
      line_3: string | null;
      /** Icon 1 */
      icon_1: string | null;
      /** Icon 2 */
      icon_2: string | null;
      /** Icon 3 */
      icon_3: string | null;
    };
    /** IntegrationProviderListResponse */
    IntegrationProviderListResponse: {
      /** Integrationproviders */
      integrationProviders: components['schemas']['IntegrationProviderResponse'][];
    };
    /** IntegrationProviderResponse */
    IntegrationProviderResponse: {
      /** Name */
      name: string;
      /** Unique Id */
      unique_id: string;
    };
    /**
     * IntegrationType
     * @enum {string}
     */
    IntegrationType: IntegrationType;
    /** IntegrationsMarketplaceEHRResponse */
    IntegrationsMarketplaceEHRResponse: {
      /** Slug */
      slug: string;
      /** Ehr Provider */
      ehr_provider: string;
      integration_type?: components['schemas']['IntegrationType'] | null;
      /** Name */
      name: string;
      /** Categories */
      categories?: components['schemas']['IntegrationCategory'][] | null;
      /** Logo */
      logo: string;
      /** Short Description */
      short_description: string;
      /** Long Description */
      long_description: string;
      /** Sort Order */
      sort_order: number;
      /** Preview Url */
      preview_url: string;
      /** Language */
      language: string;
      /** Is Live */
      is_live: boolean;
      /** Is Widget */
      is_widget: boolean | null;
      /** Is Api */
      is_api: boolean | null;
      /** Is Direct Backend */
      is_direct_backend: boolean | null;
      /** Is Gdt */
      is_gdt: boolean | null;
      /** Is Desktop */
      is_desktop: boolean | null;
      integration_feature_copy:
        | components['schemas']['IntegrationFeatureCopyResponse']
        | null;
      /** User Access Feature Flag */
      user_access_feature_flag: string | null;
      /** Entitlement Name */
      entitlement_name?: string | null;
      /** Integration Eligibility Method */
      integration_eligibility_method: string | null;
      /** Region Sort Order */
      region_sort_order?: components['schemas']['RegionSortOrder'][] | null;
      /**
       * Available Regions
       * @deprecated
       */
      available_regions?: components['schemas']['Region'][] | null;
      /** Available Countries */
      available_countries?: components['schemas']['Country'][] | null;
      /** Integrated Heidi Products */
      integrated_heidi_products?: components['schemas']['HeidiProducts'][] | null;
      /** Marketplace Card Shown Feature Flag */
      marketplace_card_shown_feature_flag?: string | null;
      /**
       * Dont Show On Marketing Site
       * @default false
       */
      dont_show_on_marketing_site: boolean;
      /**
       * Show On Pricing Planner
       * @default false
       */
      show_on_pricing_planner: boolean;
      marketing_site?: components['schemas']['MarketingSite'] | null;
      /** Hubspot Form Id */
      hubspot_form_id?: string | null;
      nango_config?: components['schemas']['NangoConfig'] | null;
      /** Scribe Capabilities */
      scribe_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Comms Capabilities */
      comms_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Evidence Capabilities */
      evidence_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Sidebar Sections */
      sidebar_sections?:
        | components['schemas']['apis__v1__integrations_marketplace__integrations_marketplace_schema__IntegrationSidebarSection'][]
        | null;
    };
    /** IntegrationsMarketplaceListResponse */
    IntegrationsMarketplaceListResponse: {
      /** Integrations */
      integrations: components['schemas']['IntegrationsMarketplaceEHRResponse'][];
      listing_page_config?: components['schemas']['ListingPageResponse'] | null;
    };
    /** InternalAdminCreateIntegrationProviderRequest */
    InternalAdminCreateIntegrationProviderRequest: {
      /** Name */
      name: string;
      /** Unique Id */
      unique_id: string;
      /** Available Countries */
      available_countries: components['schemas']['Country'][];
    };
    /** InternalAdminCreateIntegrationsMarketplaceEHRRequest */
    InternalAdminCreateIntegrationsMarketplaceEHRRequest: {
      /** Slug */
      slug: string;
      /** Language */
      language: string;
      /** Ehr Provider */
      ehr_provider: string;
      integration_type?: components['schemas']['IntegrationType'] | null;
      /** Name */
      name: string;
      /** Categories */
      categories: components['schemas']['IntegrationCategory'][];
      /** Sort Order */
      sort_order: number;
      /** Logo */
      logo?: string | null;
      /** Short Description */
      short_description?: string | null;
      /** Long Description */
      long_description?: string | null;
      /** Preview Url */
      preview_url?: string | null;
      /** Is Published */
      is_published?: boolean | null;
      /** Is Live */
      is_live?: boolean | null;
      /** Is Widget */
      is_widget?: boolean | null;
      /** Is Api */
      is_api?: boolean | null;
      /** Is Direct Backend */
      is_direct_backend?: boolean | null;
      /** Is Gdt */
      is_gdt?: boolean | null;
      /** Is Desktop */
      is_desktop?: boolean | null;
      integration_feature_copy?: components['schemas']['IntegrationFeatureCopy'] | null;
      /** User Access Feature Flag */
      user_access_feature_flag?: string | null;
      /** Entitlement Name */
      entitlement_name?: string | null;
      integration_eligibility_method?:
        | components['schemas']['IntegrationEligibilityMethod']
        | null;
      /** Region Sort Order */
      region_sort_order?: components['schemas']['RegionSortOrder'][] | null;
      /** Available Countries */
      available_countries: components['schemas']['Country'][];
      /**
       * Available Regions
       * @deprecated
       */
      available_regions?: components['schemas']['Region'][] | null;
      /** Integrated Heidi Products */
      integrated_heidi_products?: components['schemas']['HeidiProducts'][] | null;
      /** Marketplace Card Shown Feature Flag */
      marketplace_card_shown_feature_flag?: string | null;
      /** Dont Show On Marketing Site */
      dont_show_on_marketing_site?: boolean | null;
      /** Show On Pricing Planner */
      show_on_pricing_planner?: boolean | null;
      marketing_site?: components['schemas']['MarketingSite'] | null;
      /** Hubspot Form Id */
      hubspot_form_id?: string | null;
      nango_config?: components['schemas']['NangoConfig'] | null;
      /** Scribe Capabilities */
      scribe_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Comms Capabilities */
      comms_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Evidence Capabilities */
      evidence_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Sidebar Sections */
      sidebar_sections?:
        | components['schemas']['apis__v1__integrations_marketplace__integrations_marketplace_schema__IntegrationSidebarSection'][]
        | null;
    };
    /** InternalAdminIntegrationMarketplaceResponse */
    InternalAdminIntegrationMarketplaceResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Slug */
      slug: string;
      /** Language */
      language: string;
      /** Ehr Provider */
      ehr_provider: string;
      integration_type?: components['schemas']['IntegrationType'] | null;
      /** Name */
      name: string;
      /** Categories */
      categories?: components['schemas']['IntegrationCategory'][] | null;
      /** Sort Order */
      sort_order: number;
      /** Logo */
      logo?: string | null;
      /** Short Description */
      short_description?: string | null;
      /** Long Description */
      long_description?: string | null;
      /** Preview Url */
      preview_url?: string | null;
      /** Is Published */
      is_published?: boolean | null;
      /** Is Live */
      is_live?: boolean | null;
      /** Is Widget */
      is_widget?: boolean | null;
      /** Is Api */
      is_api?: boolean | null;
      /** Is Direct Backend */
      is_direct_backend?: boolean | null;
      /** Is Gdt */
      is_gdt?: boolean | null;
      /** Is Desktop */
      is_desktop?: boolean | null;
      integration_feature_copy?: components['schemas']['IntegrationFeatureCopy'] | null;
      /** User Access Feature Flag */
      user_access_feature_flag?: string | null;
      /** Entitlement Name */
      entitlement_name?: string | null;
      integration_eligibility_method?:
        | components['schemas']['IntegrationEligibilityMethod']
        | null;
      /** Region Sort Order */
      region_sort_order?: components['schemas']['RegionSortOrder'][] | null;
      /**
       * Available Regions
       * @deprecated
       */
      available_regions?: components['schemas']['Region'][] | null;
      /** Available Countries */
      available_countries?: components['schemas']['Country'][] | null;
      /** Integrated Heidi Products */
      integrated_heidi_products?: components['schemas']['HeidiProducts'][] | null;
      /** Marketplace Card Shown Feature Flag */
      marketplace_card_shown_feature_flag?: string | null;
      /** Dont Show On Marketing Site */
      dont_show_on_marketing_site?: boolean | null;
      /** Show On Pricing Planner */
      show_on_pricing_planner?: boolean | null;
      marketing_site?: components['schemas']['MarketingSite'] | null;
      /** Hubspot Form Id */
      hubspot_form_id?: string | null;
      nango_config?: components['schemas']['NangoConfig'] | null;
      /** Scribe Capabilities */
      scribe_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Comms Capabilities */
      comms_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Evidence Capabilities */
      evidence_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Sidebar Sections */
      sidebar_sections?:
        | components['schemas']['apis__v1__integrations_marketplace__integrations_marketplace_schema__IntegrationSidebarSection'][]
        | null;
    };
    /** InternalAdminIntegrationMarketplaceSuccess */
    InternalAdminIntegrationMarketplaceSuccess: {
      /** Success */
      success: boolean;
    };
    /** InternalAdminIntegrationProviderList */
    InternalAdminIntegrationProviderList: {
      /** Integration Providers */
      integration_providers: components['schemas']['InternalAdminIntegrationProviderResponse'][];
    };
    /** InternalAdminIntegrationProviderResponse */
    InternalAdminIntegrationProviderResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Unique Id */
      unique_id: string;
      /** Available Countries */
      available_countries: components['schemas']['Country'][];
    };
    /** InternalAdminIntegrationsMarketplaceEHRList */
    InternalAdminIntegrationsMarketplaceEHRList: {
      /** Integrations */
      integrations: components['schemas']['InternalAdminIntegrationMarketplaceResponse'][];
    };
    /** InternalAdminListingPageConfigResponse */
    InternalAdminListingPageConfigResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      carousel: components['schemas']['CarouselComponent-Output'];
    };
    /** InternalAdminUpdateIntegrationProviderRequest */
    InternalAdminUpdateIntegrationProviderRequest: {
      /** Name */
      name?: string | null;
      /** Available Countries */
      available_countries?: components['schemas']['Country'][] | null;
    };
    /** InternalAdminUpdateIntegrationsMarketplaceEHRRequest */
    InternalAdminUpdateIntegrationsMarketplaceEHRRequest: {
      /** Slug */
      slug?: string | null;
      /** Language */
      language?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      integration_type?: components['schemas']['IntegrationType'] | null;
      /** Name */
      name?: string | null;
      /** Categories */
      categories?: components['schemas']['IntegrationCategory'][] | null;
      /** Logo */
      logo?: string | null;
      /** Short Description */
      short_description?: string | null;
      /** Long Description */
      long_description?: string | null;
      /** Sort Order */
      sort_order?: number | null;
      /** Preview Url */
      preview_url?: string | null;
      /** Is Published */
      is_published?: boolean | null;
      /** Is Live */
      is_live?: boolean | null;
      /** Is Widget */
      is_widget?: boolean | null;
      /** Is Api */
      is_api?: boolean | null;
      /** Is Direct Backend */
      is_direct_backend?: boolean | null;
      /** Is Gdt */
      is_gdt?: boolean | null;
      /** Is Desktop */
      is_desktop?: boolean | null;
      integration_feature_copy?: components['schemas']['IntegrationFeatureCopy'] | null;
      /** User Access Feature Flag */
      user_access_feature_flag?: string | null;
      /** Entitlement Name */
      entitlement_name?: string | null;
      integration_eligibility_method?:
        | components['schemas']['IntegrationEligibilityMethod']
        | null;
      /** Region Sort Order */
      region_sort_order?: components['schemas']['RegionSortOrder'][] | null;
      /** Available Countries */
      available_countries?: components['schemas']['Country'][] | null;
      /**
       * Available Regions
       * @deprecated
       */
      available_regions?: components['schemas']['Region'][] | null;
      /** Integrated Heidi Products */
      integrated_heidi_products?: components['schemas']['HeidiProducts'][] | null;
      /** Marketplace Card Shown Feature Flag */
      marketplace_card_shown_feature_flag?: string | null;
      /** Dont Show On Marketing Site */
      dont_show_on_marketing_site?: boolean | null;
      /** Show On Pricing Planner */
      show_on_pricing_planner?: boolean | null;
      marketing_site?: components['schemas']['MarketingSite'] | null;
      /** Hubspot Form Id */
      hubspot_form_id?: string | null;
      nango_config?: components['schemas']['NangoConfig'] | null;
      /** Scribe Capabilities */
      scribe_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Comms Capabilities */
      comms_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Evidence Capabilities */
      evidence_capabilities?:
        | components['schemas']['apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability'][]
        | null;
      /** Sidebar Sections */
      sidebar_sections?:
        | components['schemas']['apis__v1__integrations_marketplace__integrations_marketplace_schema__IntegrationSidebarSection'][]
        | null;
    };
    /** InternalAdminUpsertListingPageConfigRequest */
    InternalAdminUpsertListingPageConfigRequest: {
      carousel: components['schemas']['CarouselComponent-Input'];
    };
    /** InternalTemplateListResponse */
    InternalTemplateListResponse: {
      /** Templates */
      templates: components['schemas']['TemplateBasicInfo'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
      /** Pages */
      pages: number;
    };
    /**
     * LikeRequest
     * @description Request body for like operations.
     */
    LikeRequest: {
      user: components['schemas']['UserInfo'];
    };
    /**
     * LikeResponse
     * @description Response for like/unlike operations.
     */
    LikeResponse: {
      /** Liked */
      liked: boolean;
      /** Likes Count */
      likes_count: number;
    };
    /**
     * LikeStatusResponse
     * @description Response for checking like status.
     */
    LikeStatusResponse: {
      /** Liked */
      liked: boolean;
    };
    /** ListingPageCarouselBlockResponse */
    ListingPageCarouselBlockResponse: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Subtitle */
      subtitle: string;
      /** Integration Slugs */
      integration_slugs: string[];
    };
    /** ListingPageCarouselResponse */
    ListingPageCarouselResponse: {
      /** Title */
      title: string;
      /** Background Image Url */
      background_image_url: string;
      /** Blocks */
      blocks: components['schemas']['ListingPageCarouselBlockResponse'][];
    };
    /** ListingPageResponse */
    ListingPageResponse: {
      carousel: components['schemas']['ListingPageCarouselResponse'];
    };
    /** MarketingSite */
    MarketingSite: {
      custom_onboarding?: components['schemas']['MarketingSiteCustomOnboarding'] | null;
    };
    /** MarketingSiteCustomOnboarding */
    MarketingSiteCustomOnboarding: {
      /** Text */
      text: string;
      /** Url */
      url: string;
    };
    /** NangoConfig */
    NangoConfig: {
      /** Provider Config Key */
      provider_config_key?: string | null;
    };
    /**
     * Region
     * @enum {string}
     */
    Region: Region;
    /** RegionSortOrder */
    RegionSortOrder: {
      /** Region */
      region: string;
      /** Order Number */
      order_number: number;
    };
    /** RejectAnswerRequest */
    RejectAnswerRequest: {
      /** Rejection Reason */
      rejection_reason: string;
      /** Reviewed By */
      reviewed_by?: string | null;
    };
    /** SeoContext */
    SeoContext: {
      /** Form Purpose */
      form_purpose: string;
      /** Who Fills It */
      who_fills_it: string;
      /** Required Information Categories */
      required_information_categories: string;
      /** Friction Points */
      friction_points: string;
      /** Heidi Value */
      heidi_value: string;
    };
    /** SeoFieldsUpdate */
    SeoFieldsUpdate: {
      /** Seo Content */
      seo_content?: string | null;
      seo_context?: components['schemas']['SeoContext'] | null;
    };
    /** SpecialtyGroupsUpdate */
    SpecialtyGroupsUpdate: {
      /** Specialty Groups */
      specialty_groups: string[];
    };
    /** TemplateBasicInfo */
    TemplateBasicInfo: {
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      /** Title */
      title: string;
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Deleted At */
      deleted_at?: string | null;
      template_category: components['schemas']['TemplateCategory'];
      source_region: components['schemas']['Region'];
      /**
       * Country
       * @default
       */
      country: string;
      /** Specialty */
      specialty: string;
      /**
       * Clinical Content Group
       * @default
       */
      clinical_content_group: string;
      /**
       * Specialty Groups
       * @default []
       */
      specialty_groups: string[];
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Clinic Id */
      clinic_id?: string | null;
      /** Clinic Name */
      clinic_name?: string | null;
      /** Views Count */
      views_count: number;
      /** Imports Count */
      imports_count: number;
      /**
       * Likes Count
       * @default 0
       */
      likes_count: number;
      /** Url Path */
      url_path: string;
      form_format?: components['schemas']['FormFormat'] | null;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
    };
    /**
     * TemplateCategory
     * @enum {string}
     */
    TemplateCategory: TemplateCategory;
    /** TemplateContentUpdate */
    TemplateContentUpdate: {
      /** Title */
      title?: string | null;
      /** Description */
      description?: string | null;
      /** Structure */
      structure?: string | null;
      /** Html */
      html?: string | null;
      /** Tone */
      tone?: string | null;
      /** Example Output */
      example_output?: string | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      form_format?: components['schemas']['FormFormat'] | null;
      /** Xml Source */
      xml_source?: string | null;
      /** Seo Content */
      seo_content?: string | null;
      seo_context?: components['schemas']['SeoContext'] | null;
    };
    /** TemplateContentV1 */
    TemplateContentV1: {
      /** Title */
      title: string;
      /**
       * Description
       * @default
       */
      description: string;
      /** Structure */
      structure: string;
      /** Html */
      html?: string | null;
      /**
       * Tone
       * @default
       */
      tone: string;
      /** Example Output */
      example_output: string;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** @default pdf */
      form_format: components['schemas']['FormFormat'];
      /** Xml Source */
      xml_source?: string | null;
      /** Seo Content */
      seo_content?: string | null;
      seo_context?: components['schemas']['SeoContext'] | null;
    };
    /** TemplateFailedItem */
    TemplateFailedItem: {
      /** Template Id */
      template_id: string;
      /** Error */
      error: string;
    };
    /**
     * TemplateFilterBy
     * @enum {string}
     */
    TemplateFilterBy: TemplateFilterBy;
    /** TemplateResponse */
    TemplateResponse: {
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      /** Title */
      title: string;
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Deleted At */
      deleted_at?: string | null;
      template_category: components['schemas']['TemplateCategory'];
      source_region: components['schemas']['Region'];
      /**
       * Country
       * @default
       */
      country: string;
      /** Specialty */
      specialty: string;
      /**
       * Clinical Content Group
       * @default
       */
      clinical_content_group: string;
      /**
       * Specialty Groups
       * @default []
       */
      specialty_groups: string[];
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Clinic Id */
      clinic_id?: string | null;
      /** Clinic Name */
      clinic_name?: string | null;
      /** Views Count */
      views_count: number;
      /** Imports Count */
      imports_count: number;
      /**
       * Likes Count
       * @default 0
       */
      likes_count: number;
      /** Url Path */
      url_path: string;
      form_format?: components['schemas']['FormFormat'] | null;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
    };
    /** TemplateVersion */
    TemplateVersion: {
      /** Version Number */
      version_number: number;
      content: components['schemas']['TemplateContentV1'];
      /** Published At */
      published_at?: string | null;
    };
    /** UpdateHeidiAnswerRequest */
    UpdateHeidiAnswerRequest: {
      /** Question Title */
      question_title?: string | null;
      /** Question Slug */
      question_slug?: string | null;
      /** Specialty */
      specialty?: string | null;
      /** Condition */
      condition?: string | null;
      /** Question Type */
      question_type?: string | null;
      /** Direct Answer */
      direct_answer?: string | null;
      /** Validator Name */
      validator_name?: string | null;
      /** Validator Credentials */
      validator_credentials?: string | null;
      /** Validator Specialty */
      validator_specialty?: string | null;
      /** Validator Role */
      validator_role?: string | null;
      /** Country */
      country?: string | null;
      /** Validation Date */
      validation_date?: string | null;
      /** Last Reviewed Date */
      last_reviewed_date?: string | null;
      /** Og Title */
      og_title?: string | null;
      /** Og Description */
      og_description?: string | null;
      /** Source Evidence Id */
      source_evidence_id?: string | null;
    };
    /** UpdateTemplateRequest */
    UpdateTemplateRequest: {
      template_category?: components['schemas']['TemplateCategory'] | null;
      /** Specialty */
      specialty?: string | null;
      /** Country */
      country?: string | null;
      /** Author Name */
      author_name?: string | null;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      template_content?: components['schemas']['TemplateContentUpdate'] | null;
      /** Url Path */
      url_path?: string | null;
    };
    /**
     * UserInfo
     * @description User information for internal service calls.
     */
    UserInfo: {
      /** User Id */
      user_id: string;
      /** User Display Name */
      user_display_name?: string | null;
      /** User Profile Picture */
      user_profile_picture?: string | null;
    };
    /** ValidationError */
    ValidationError: {
      /** Location */
      loc: (string | number)[];
      /** Message */
      msg: string;
      /** Error Type */
      type: string;
    };
    /** IntegrationSidebarSection */
    apis__v1__integrations_marketplace__integrations_marketplace_schema__IntegrationSidebarSection: {
      /** Name */
      name: string;
    };
    /** IntegrationCapability */
    apis__v1__integrations_marketplace_admin__integrations_marketplace_schema__IntegrationCapability: {
      /** Description */
      description: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
};
export type $defs = Record<string, never>;
export interface operations {
  get_templates_api_v1_template_gallery_templates__get: {
    parameters: {
      query?: {
        /** @description Filter criteria in format as field:operator:value */
        filter?: string[] | null;
        /** @description Search criteria */
        search?: string | null;
        /** @description Sort criteria */
        sort?: string[] | null;
        /** @description Page number */
        page?: number | null;
        /** @description Number of items per page */
        page_size?: number | null;
        /** @description Enable recommendation */
        enable_recommendation?: boolean | null;
        /** @description Specialty groups to expand search when few results are found */
        specialty_groups?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplateListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_by_url_path_api_v1_template_gallery_templates__url_path__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        url_path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_templates_api_v1_internal_template_gallery_templates__get: {
    parameters: {
      query?: {
        /** @description Page number (1-indexed) */
        page?: number;
        /** @description Items per page (max 100) */
        page_size?: number;
        /** @description Filter by template category */
        template_category?: components['schemas']['TemplateCategory'] | null;
        /** @description Filter by source region */
        source_region?: components['schemas']['Region'] | null;
        /** @description Filter by country */
        country?: string | null;
        /** @description Filter by specialty name */
        specialty?: string | null;
        /** @description Filter by author's kinde_user_id */
        author_id?: string | null;
        /** @description Include soft-deleted templates */
        include_deleted?: boolean;
        /** @description Search in title and description */
        search?: string | null;
        /** @description Sort as field:order (e.g., created_at:-1). Fields: created_at, updated_at, views_count, imports_count, title, template_category. Order: 1=asc, -1=desc */
        sort?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalTemplateListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_api_v1_internal_template_gallery_templates__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_create_templates_api_v1_internal_template_gallery_templates_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchCreateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchCreateTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_delete_templates_api_v1_internal_template_gallery_templates_batch_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchDeleteTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchDeleteTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_update_templates_api_v1_internal_template_gallery_templates_batch_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchUpdateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchUpdateTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_update_by_specialty_api_v1_internal_template_gallery_templates_bulk_update_by_specialty_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkUpdateBySpecialtyRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkUpdateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_set_seo_fields_api_v1_internal_template_gallery_templates_bulk_set_seo_fields_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkSetSeoFieldsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkSetSeoFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_by_id_api_v1_internal_template_gallery_templates__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_template_as_deleted_api_v1_internal_template_gallery_templates__template_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_api_v1_internal_template_gallery_templates__template_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  restore_template_api_v1_internal_template_gallery_templates__template_id__restore_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_template_by_id_api_v1_internal_template_gallery_templates__template_id__import_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_like_status_api_v1_internal_template_gallery_templates__template_id__like_get: {
    parameters: {
      query: {
        /** @description User ID */
        user_id: string;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LikeStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  like_template_api_v1_internal_template_gallery_templates__template_id__like_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LikeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LikeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlike_template_api_v1_internal_template_gallery_templates__template_id__like_delete: {
    parameters: {
      query: {
        /** @description User ID */
        user_id: string;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LikeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_batch_like_status_api_v1_internal_template_gallery_templates_likes_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchLikeStatusRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchLikeStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  healthcheck_api_v1_template_gallery_healthcheck_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  generate_jwt_api_v1_template_gallery_auth_token_post: {
    parameters: {
      query: {
        source_region: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateJWTResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integrations_api_v1_template_gallery_integrations_marketplace_integrations_get: {
    parameters: {
      query?: {
        language?: string;
        include_english?: boolean;
        region?: components['schemas']['Region'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationsMarketplaceListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integration_providers_api_v1_template_gallery_integrations_marketplace_integrations_integration_providers_get: {
    parameters: {
      query?: {
        country?: components['schemas']['Country'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationProviderListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_integration_by_slug_and_language_api_v1_template_gallery_integrations_marketplace_integrations__language___integration_slug__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        language: string;
        integration_slug: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationsMarketplaceEHRResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_integration_by_ehr_provider_and_language_api_v1_template_gallery_integrations_marketplace_integrations_general_get: {
    parameters: {
      query: {
        language: string;
        ehr_provider: string;
        include_unpublished?: boolean;
        use_simple_response?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationsMarketplaceEHRResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integrations_api_v1_internal_template_gallery_integrations_marketplace_integrations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationsMarketplaceEHRList'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_integration_api_v1_internal_template_gallery_integrations_marketplace_integrations_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateIntegrationsMarketplaceEHRRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationMarketplaceResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  integration_by_id_api_v1_internal_template_gallery_integrations_marketplace_integrations__integration_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        integration_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationMarketplaceResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_integration_api_v1_internal_template_gallery_integrations_marketplace_integrations__integration_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        integration_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationMarketplaceSuccess'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_integration_api_v1_internal_template_gallery_integrations_marketplace_integrations__integration_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        integration_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateIntegrationsMarketplaceEHRRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationMarketplaceResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integration_providers_api_v1_internal_template_gallery_integrations_marketplace_integration_providers_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationProviderList'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_integration_provider_api_v1_internal_template_gallery_integrations_marketplace_integration_providers_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateIntegrationProviderRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationProviderResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  integration_provider_by_id_api_v1_internal_template_gallery_integrations_marketplace_integration_providers__provider_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationProviderResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_integration_provider_api_v1_internal_template_gallery_integrations_marketplace_integration_providers__provider_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationMarketplaceSuccess'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_integration_provider_api_v1_internal_template_gallery_integrations_marketplace_integration_providers__provider_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateIntegrationProviderRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminIntegrationProviderResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_listing_page_config_api_v1_internal_template_gallery_integrations_marketplace_listing_page_config_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['InternalAdminListingPageConfigResponse']
            | null;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  upsert_listing_page_config_api_v1_internal_template_gallery_integrations_marketplace_listing_page_config_put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpsertListingPageConfigRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminListingPageConfigResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_published_answers_api_v1_template_gallery_heidi_answers__get: {
    parameters: {
      query?: {
        specialty?: string | null;
        country?: string | null;
        question_type?: string | null;
        condition?: string | null;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_answer_by_slug_api_v1_template_gallery_heidi_answers__slug__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_answers_api_v1_internal_template_gallery_heidi_answers__get: {
    parameters: {
      query?: {
        specialty?: string | null;
        country?: string | null;
        question_type?: string | null;
        condition?: string | null;
        search?: string | null;
        status?: string | null;
        include_deleted?: boolean;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_answer_api_v1_internal_template_gallery_heidi_answers__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateHeidiAnswerRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        answer_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__delete: {
    parameters: {
      query?: {
        hard?: boolean;
      };
      header?: never;
      path: {
        answer_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        answer_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateHeidiAnswerRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  approve_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__approve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        answer_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ApproveAnswerRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reject_answer_api_v1_internal_template_gallery_heidi_answers__answer_id__reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        answer_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RejectAnswerRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiAnswerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_upload_csv_api_v1_internal_template_gallery_heidi_answers_batch_upload_post: {
    parameters: {
      query?: {
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_upload_csv_api_v1_internal_template_gallery_heidi_answers_batch_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkUploadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
}
export enum Country {
  AF = 'AF',
  AX = 'AX',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BQ = 'BQ',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  CV = 'CV',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CK = 'CK',
  CR = 'CR',
  CI = 'CI',
  HR = 'HR',
  CU = 'CU',
  CW = 'CW',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  SZ = 'SZ',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IM = 'IM',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MG = 'MG',
  MW = 'MW',
  MY = 'MY',
  MV = 'MV',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MK = 'MK',
  MP = 'MP',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  BL = 'BL',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SG = 'SG',
  SX = 'SX',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TH = 'TH',
  TL = 'TL',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  GB = 'GB',
  US = 'US',
  UM = 'UM',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
}
export enum FormFormat {
  pdf = 'pdf',
  xml = 'xml',
}
export enum HeidiProducts {
  SCRIBE = 'SCRIBE',
  EVIDENCE = 'EVIDENCE',
  COMMS = 'COMMS',
}
export enum IntegrationCategory {
  medical_record = 'medical-record',
  file_management = 'file-management',
  communication_telehealth = 'communication-telehealth',
  calendar = 'calendar',
  documentation = 'documentation',
  crm = 'crm',
  e_sign = 'e-sign',
}
export enum IntegrationEligibilityMethod {
  TOGETHER_OR_ENTERPRISE_TIER = 'TOGETHER_OR_ENTERPRISE_TIER',
  ADD_ON_PRODUCT = 'ADD_ON_PRODUCT',
  FEATURE_FLAGGED = 'FEATURE_FLAGGED',
  ENTITLEMENT = 'ENTITLEMENT',
  PRO_AND_ABOVE = 'PRO_AND_ABOVE',
}
export enum IntegrationType {
  EMR = 'EMR',
  Nango = 'Nango',
}
export enum Region {
  UK = 'UK',
  CA = 'CA',
  US = 'US',
  AU = 'AU',
  EU = 'EU',
}
export enum TemplateCategory {
  CONSULT_NOTE_TEMPLATE = 'CONSULT_NOTE_TEMPLATE',
  DOCUMENT_TEMPLATE = 'DOCUMENT_TEMPLATE',
  FORM_TEMPLATE = 'FORM_TEMPLATE',
}
export enum TemplateFilterBy {
  template_category = 'template_category',
  source_region = 'source_region',
  specialty = 'specialty',
  clinical_content_group = 'clinical_content_group',
  specialty_groups = 'specialty_groups',
  views_count = 'views_count',
  imports_count = 'imports_count',
  country = 'country',
}
